/* eslint-disable react/jsx-pascal-case */
import { Controller, useFormContext } from "react-hook-form";
import { useRecoilValue } from "recoil";
import SelectHookFormSingle from "../../../../components/SelectHookFormSingle";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
//Hook form Data
import { useGetActiveGLEntity } from "../hooks/useGetActiveGLEntity";
import { useGetState } from "../hooks/useGetState";
import { useGetActiveOfficeBMO } from "../hooks/useGetActiveOfficeBMO";
import { useGetActiveOfficeDivision } from "../hooks/useGetActiveOfficeDivision";
import { useGetActiveTexasGrouping } from "../hooks/useGetActiveTexasGrouping";
import { officeAddState, officeEditState } from "../atoms/atoms";
import { useGetActiveOfficeDepartment } from "../hooks/useGetActiveOfficeDepartment";
import { OFFICEFIELD_PERMISSIONS } from "../permission";

const OfficeBIandA = ({ disableFields }) => {
  const formMethods = useFormContext();
  const { data: statesData, isLoading: statesLoading } = useGetState();
  const allState = statesData?.map((resData) => {
    return {
      label: resData.description.trim(),
      value: resData.stateId,
      state: resData.state,
    };
  });
  const isEditState = useRecoilValue(officeEditState);
  const isAddState = useRecoilValue(officeAddState);
  const userPermissions = useRecoilValue(permissionsSelector);
  const glBranchAccess =
    OFFICEFIELD_PERMISSIONS.fieldpermission_office_glbranch;
  const bmoAccess = OFFICEFIELD_PERMISSIONS.fieldpermission_office_bmo;
  const divisionAccess =
    OFFICEFIELD_PERMISSIONS.fieldpermission_office_officedivision;
  const departmentAccess =
    OFFICEFIELD_PERMISSIONS.fieldpermission_office_officedepartment;
  const { data: glEntities } = useGetActiveGLEntity();
  const activeGLEntity = glEntities
    ?.filter((x) => x.isActive === true)
    ?.map((y) => {
      return {
        ...y,
        label: y.glnumber + "-" + y.glentityName,
        value: y.glnumber,
      };
    });
  const { data: activeBMOs, isLoading: bmoLoading } = useGetActiveOfficeBMO();
  const bmoOptions = activeBMOs?.map((x) => {
    return { label: x.bmoName, value: x.bmoId };
  });
  const { data: activeDivisions, isLoading: divisionsLoading } =
    useGetActiveOfficeDivision();
  const divisionsOptions = activeDivisions?.map((x) => {
    return {
      label: x.divisionName + " - " + x.divisionCode,
      value: x.divisionId,
    };
  });
  const { data: activeTexasGrouping, isLoading: texasLoading } =
    useGetActiveTexasGrouping();
  const texasOptions = activeTexasGrouping?.map((x) => {
    return {
      label: x.texasGroupingName,
      value: x.texasGroupingId,
    };
  });
  const { data: activeDepartments, isLoading: departmentLoading } =
    useGetActiveOfficeDepartment();
  const departmentsOptions = activeDepartments?.map((x) => {
    return {
      label: x.officeDepartmentName,
      value: x.officeDepartmentId,
    };
  });
  return (
    <div className="m-2 bg-white box-shadow rounded-lg h-full p-1 pb-4">
      <div className="text-quinary font-bold font-sans py-2 px-4">{"BI&A"}</div>
      <div className="grid grid-cols-1 md:grid-cols-2 px-4 gap-12">
        <div className="space-y-1">
          <Controller
            control={formMethods.control}
            name="bmoId"
            rules={{
              required: userPermissions.includes(bmoAccess) && isEditState,
            }}
            render={({ field }) => (
              <SelectHookFormSingle
                field={field}
                onChange={(e) => {
                  field.onChange(e ? e.value : null);
                }}
                value={field.value}
                isLoading={bmoLoading}
                options={bmoOptions}
                label="BMO"
                className={
                  formMethods.formState.errors.bmoId &&
                  "border-2 border-red-500 col-span-2 "
                }
                required={userPermissions.includes(bmoAccess) && isEditState}
                isDisabled={
                  !userPermissions.includes(bmoAccess) ||
                  disableFields ||
                  isAddState
                }
              />
            )}
          />

          <Controller
            control={formMethods.control}
            name="texasGroupingId"
            render={({ field }) => (
              <SelectHookFormSingle
                field={field}
                onChange={(e) => {
                  field.onChange(e ? e.value : null);
                }}
                value={field.value}
                options={texasOptions}
                isLoading={texasLoading}
                label="Texas Grouping"
                isDisabled={disableFields}
              />
            )}
          />
          <Controller
            control={formMethods.control}
            rules={{
              required: userPermissions.includes(divisionAccess) && isEditState,
            }}
            name="officeDivisionCodeId"
            render={({ field }) => (
              <SelectHookFormSingle
                field={field}
                onChange={(e) => {
                  field.onChange(e ? e.value : null);
                }}
                value={field.value}
                options={divisionsOptions}
                isLoading={divisionsLoading}
                label="Office Division"
                className={
                  formMethods.formState.errors.officeDivisionCodeId &&
                  "border-2 border-red-500 col-span-2 "
                }
                required={
                  userPermissions.includes(divisionAccess) && isEditState
                }
                isDisabled={
                  !userPermissions.includes(divisionAccess) ||
                  disableFields ||
                  isAddState
                }
              />
            )}
          />
        </div>
        <div className="space-y-1">
          <Controller
            control={formMethods.control}
            name="glBranch"
            rules={{
              required: userPermissions.includes(glBranchAccess) && isEditState,
            }}
            render={({ field }) => (
              <SelectHookFormSingle
                field={field}
                onChange={(e) => {
                  field.onChange(e ? e.value : null);
                  formMethods.setValue("glBranch", e ? e?.value : null);
                  formMethods.setValue(
                    "glEntityName",
                    e ? e?.glentityName : null
                  );
                  formMethods.setValue("glIsActive", e ? e?.isActive : null);
                }}
                value={field.value}
                options={activeGLEntity}
                label="GL Branch"
                className={
                  formMethods.formState.errors.glBranch &&
                  "border-2 border-red-500 col-span-2 "
                }
                required={
                  userPermissions.includes(glBranchAccess) && isEditState
                }
                isDisabled={
                  !userPermissions.includes(glBranchAccess) ||
                  disableFields ||
                  isAddState
                }
              />
            )}
          />
          <Controller
            name="stateForReportingId"
            control={formMethods.control}
            render={({ field }) => (
              <SelectHookFormSingle
                field={field}
                onChange={(e) => {
                  field.onChange(e ? e.value : null);
                }}
                value={field.value}
                isLoading={statesLoading}
                options={allState}
                label="State For Reporting"
                isDisabled={disableFields}
              />
            )}
          />
          <Controller
            control={formMethods.control}
            name="officeDepartmentId"
            render={({ field }) => (
              <SelectHookFormSingle
                field={field}
                onChange={(e) => {
                  field.onChange(e ? e.value : null);
                  formMethods.setValue(
                    "officeDepartmentName",
                    e ? e?.label : null
                  );
                }}
                value={field.value}
                options={departmentsOptions}
                isLoading={departmentLoading}
                label="Office Department"
                isDisabled={
                  !userPermissions.includes(departmentAccess) || disableFields
                }
              />
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default OfficeBIandA;
